import React from 'react';

import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { isEmpty } from 'lodash';
import arrow from '@assets/images/gallery/right-arrow.svg';
import { DATE_ONLY_MONTH_FORMAT } from '@share/constants';
import { DATE_FORMAT } from '@share/constants';
import { IAccount, ICarsRecentSearches } from '@share/common-types';
import { formatDateCheckInOut } from '@share/utils';

import { CarsSearchHandlerArgs } from '../cars-recent-searches-wrapper';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCalendar, faLocation, faReply } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

interface IProps extends WrappedComponentProps {
  data: ICarsRecentSearches;
  disabled: boolean;
  account: IAccount;

  onSearchHandler: CarsSearchHandlerArgs;
}

class CarsRecentSearchesComponent extends React.Component<IProps> {
  render(): React.ReactNode {
    const { data, disabled, account, onSearchHandler } = this.props;
    const { carRequest, dropOffLocation, pickUpLocation, filter } = data;
    const { pickUpDate, pickUpTime, returnDate, returnTime, driverAge, countryISO } = carRequest;

    const formattedStartDate = pickUpDate && formatDateCheckInOut(pickUpDate, DATE_ONLY_MONTH_FORMAT);
    const formattedEndDate = returnDate && formatDateCheckInOut(returnDate, DATE_FORMAT);

    const color: any = account?.searchIconsColor;
    const generalBorderRadius: any = account?.generalBorderRadius ? account?.generalBorderRadius : null;

    const style = !isEmpty(generalBorderRadius) ? { borderRadius: generalBorderRadius } : {};
    const styleColor = !isEmpty(color) ? { color } : {};
    const buttonColor = account?.buttonColor;

    function truncateString(str, num) {
      if (str?.length <= num) {
        return str;
      }
      return str?.slice(0, num) + '...';
    }

    return (
      <div
        role="button"
        className={`recent-searches-picker card card-body history-card-text border-1 shadow-sm p-2 ${disabled ? 'disabled' : ''}`}
        style={style}
        onClick={() => {
          if (!disabled) {
            onSearchHandler(
              pickUpLocation,
              dropOffLocation,
              pickUpDate,
              returnDate,
              pickUpTime,
              returnTime,
              driverAge,
              countryISO,
              filter?.simpleType,
              filter?.rateDistance,
              filter?.rentalCompany,
              filter?.fuel
            );
          }
        }}
      >
        <div className="search-recents-picker__info">
          <h6 className="search-recents-picker__title mb-1 mt-1">
            <FontAwesomeIcon icon={faLocation} className='me-3 mt-1' style={{ ...styleColor }} />
            <span title={pickUpLocation.name}>
              {truncateString(pickUpLocation.name, 50)}
            </span>
          </h6>
          <h6 className="search-recents-picker__title mb-1 mt-1">
            <FontAwesomeIcon icon={faReply} className='me-3 mt-1' style={{ ...styleColor }} />
            <span>
              {(!isEmpty(dropOffLocation?.name) && dropOffLocation?.code !== pickUpLocation?.code) ? dropOffLocation?.name : <FormattedMessage id="cars.dropoff.location.placeholder" />}
            </span>
          </h6>

          <h6 className="recent-searches-picker__subtitle mb-1 mt-1 ttl pb-4">
            <FontAwesomeIcon icon={faCalendar} className='me-3 mt-1' style={{ ...styleColor }} />
            <span>
              {formattedStartDate}, {pickUpTime} - {formattedEndDate}, {returnTime}
            </span>
          </h6>

          <div className={`search-again secondary-font`} style={{color: `${buttonColor}`}}>
            <FormattedMessage id="availability.status.modal.search_again" />
            <img src={arrow} width={25} className="mx-2" />
          </div>
        </div>

        {/* 
        <div className="recent-searches-picker__info" style={{ width: '20px', ...styleColor }}>
          <FontAwesomeIcon icon={faLocation} className='me-2' />
          <FontAwesomeIcon icon={faReply} />
          <FontAwesomeIcon icon={faCalendar} />
        </div>

        <div className="recent-searches-picker__info">
          <p className="recent-searches-picker__title mb-1 mt-1">{pickUpLocation.name}</p>
          <p className="recent-searches-picker__title mb-1 mt-1">{(!isEmpty(dropOffLocation?.name) && dropOffLocation?.code !== pickUpLocation?.code) ? dropOffLocation?.name : <FormattedMessage id="cars.dropoff.location.placeholder" />}</p>
          <p className="recent-searches-picker__subtitle ttl">
            <span>
              {formattedStartDate}, {pickUpTime} - {formattedEndDate}, {returnTime}
            </span>
          </p>

          <div className={`search-again secondary-font ${disabled ? 'disabled' : ''}`}>
            <FormattedMessage id="availability.status.modal.search_again" />
            <FontAwesomeIcon icon={faArrowRight} />
          </div>
        </div> */}
      </div>
    );
  }
}

export const CarsRecentSearchesItem = injectIntl(CarsRecentSearchesComponent);
